import React, { useEffect, useState } from "react"
import Split from "react-split"
import styles from "./Home.module.scss"
import Sidebar from "../Sidebar/Sidebar"
import Tabs from "../Tabs/Tabs"
import Blank from "../Sessions/Blank/Blank"
import { UserInterface } from "../../App"
import Chat from "../Sessions/Chat/Chat"
import AppSpace from "../AppSpace/AppSpace"
import { FileItem } from "../Sessions/Chat/Files/Files"
import Wikis from "../Wikis/Wikis"

interface HomeProps {
    setUser: any
    user: UserInterface
}

export interface ChatModeInterface {
    chatMode: "" | "asking all files" | "asking open file" | "asking the web" | "web search only"
}

const Home: React.FC<HomeProps> = ({ setUser, user }) => {
    const [sessionCount, setSessionCount] = useState(0)
    const [sessions, setSessions] = useState<any>([
        {
            name: "New Session",
            id: Date.now(),
            view: "chat",
            component: null,
            send: null,
            createFile: null,
        },
    ])
    const [activeSession, setActiveSession] = useState(sessions[0])

    const [appSpaces, setAppSpaces] = useState<any>([])
    const [activeAppSpace, setActiveAppSpace] = useState<any>({})
    const [rawContext, setRawContext] = useState("")
    const [fileTree, setFileTree] = useState<FileItem[]>([])

    const [messages, setMessages] = useState<any>({})

    const [chatMode, setChatMode] = useState<ChatModeInterface["chatMode"]>("")

    const [lightMode, setLightMode] = useState(false)
    const [orgWikis, setOrgWikis] = useState<any>([])

    function toggleLightMode() {
        setLightMode(!lightMode)
    }

    useEffect(() => {
        if (lightMode) {
            document.body.classList.add("light-mode")
        } else {
            document.body.classList.remove("light-mode")
        }
    }, [lightMode])

    function newSession({ name, component, id, view, send, createFile }: any = {}) {
        const existingSession = sessions.find((session: any) => session.id === id)
        if (existingSession) {
            setActiveSession(existingSession)
            return
        }

        setSessionCount(sessionCount + 1)
        const newSession = {
            name: name || `Session ${sessionCount + 1}`,
            component,
            id: id || Date.now(),
            view,
            send,
            createFile,
        }
        setSessions([...sessions, newSession])
        setActiveSession(newSession)
    }

    function newAppSpace(file: any) {
        const existingAppSpace = appSpaces.find((appSpace: any) => appSpace.id === file.fileId)
        if (existingAppSpace) setActiveAppSpace(existingAppSpace)
        else {
            if (!file?.name || !file.fileId) return
            const newAppSpace = {
                id: file.fileId,
                fileId: file.fileId,
                ...file,
            }
            setAppSpaces([...appSpaces, newAppSpace])
            setActiveAppSpace(newAppSpace)
        }
    }

    function matchSession(session: any) {
        if (session.view === "chat")
            return (
                <Chat
                    activeAppSpace={activeAppSpace}
                    setActiveAppSpace={setActiveAppSpace}
                    newAppSpace={newAppSpace}
                    appSpaces={appSpaces}
                    rawContext={rawContext}
                    setUser={setUser}
                    activeSession={activeSession}
                    user={user}
                    send={session.send}
                    createFile={session.createFile}
                    chatMode={chatMode}
                    setChatMode={setChatMode}
                    messages={messages}
                    setMessages={setMessages}
                    sessions={sessions}
                    fileTree={fileTree}
                    setFileTree={setFileTree}
                />
            )
        else if (session.view === "wikis") {
            return (
                <Wikis
                    user={user}
                    setUser={setUser}
                    newAppSpace={newAppSpace}
                    setOrgWikis={setOrgWikis}
                    activeAppSpace={activeAppSpace}
                />
            )
        } else
            return (
                <Blank
                    newSession={newSession}
                    user={user}
                    setUser={setUser}
                    chatMode={chatMode}
                    setChatMode={setChatMode}
                />
            )
    }

    const appSpacesOpenAndActive = appSpaces?.length > 0

    return (
        <div className={styles.Home}>
            {/* Tabless Pretzel */}
            {/* <div style={{ justifyContent: "space-between", display: "flex" }}>
                <Tabs
                    newSession={newSession}
                    setSessions={setSessions}
                    sessions={sessions}
                    setActiveSession={setActiveSession}
                    activeSession={activeSession}
                />
                {appSpacesOpenAndActive && (
                    <Tabs
                        appSpaces={true}
                        newSession={newAppSpace}
                        setSessions={setAppSpaces}
                        sessions={appSpaces}
                        setActiveSession={setActiveAppSpace}
                        activeSession={activeAppSpace}
                    />
                )}
            </div> */}
            <Split
                sizes={appSpacesOpenAndActive ? [60, 40] : [100, 0]}
                minSize={appSpacesOpenAndActive ? 400 : 0}
                maxSize={[Infinity, 1000]}
                direction="horizontal"
                className={styles.divider}>
                <Split sizes={[22, 78]} direction="horizontal" className={styles.divider}>
                    <Sidebar
                        setUser={setUser}
                        user={user}
                        newSession={newSession}
                        newAppSpace={newAppSpace}
                        messages={messages}
                        setMessages={setMessages}
                        activeSession={activeSession}
                        toggleLightMode={toggleLightMode}
                        fileTree={fileTree}
                        setFileTree={setFileTree}
                    />
                    <div className={styles.content} style={{ flex: 1, minWidth: 0 }}>
                        {sessions.map((session: any, index: number) => (
                            <div
                                style={{
                                    display: activeSession.id === session.id ? "block" : "none",
                                    height: "100%",
                                }}
                                key={index}>
                                {!session.component ? matchSession(session) : session.component}
                            </div>
                        ))}
                    </div>
                </Split>
                <AppSpace
                    setRawContext={setRawContext}
                    appSpaces={appSpaces}
                    setAppSpaces={setAppSpaces}
                    activeAppSpace={activeAppSpace}
                    setActiveAppSpace={setActiveAppSpace}
                    user={user}
                    lightMode={lightMode}
                    orgWikis={orgWikis}
                />
            </Split>
        </div>
    )
}

export default Home
